document.addEventListener('DOMContentLoaded', function () {
  const slideCounter = document.querySelector('.ed-main-product .product .slider-buttons .slider-counter');
  const slideItems = document.querySelectorAll('.ed-main-product .product .slider__slide');

  if (slideItems.length < 3) {
    if (slideCounter) {
      slideCounter.remove();
    }
  }
});